import React from "react";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button/Button";
import TextField from "@material-ui/core/TextField/TextField";
import {withRouter} from 'react-router-dom'
import * as routes from "../../constants/routes";
import {compose} from 'recompose';
import {withAuth} from "../../firebase/context";

class Admin extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error: '',
        }
    }

    async handleSignIn() {
        const {auth} = this.props;
        const {email, password} = this.state;

        const currentUser = await auth.trySignInWithEmailAndPassword(email, password)
            .catch((error) => {
                this.setState({
                    error: error.toString(),
                });
            });

        if (currentUser) {
            this.props.history.push(routes.dashboard);
        }
    }

    handleKeyPress(event) {
        if (event.key === "Enter") {
            return this.handleSignIn();
        }
    }

    render() {
        return (
            <div className="full_center_container">
                <Card style={{flexWrap: 'wrap'}}>
                    <CardContent>
                        <Typography style={{fontSize: 16, maxWidth: '40vw', height: 40, marginBottom: 16, color: 'red'}}
                                    color="textPrimary">
                            {this.state.error}
                        </Typography>

                        <form noValidate autoComplete="off">

                            <TextField
                                id="login_email_field"
                                placeholder="Email"
                                type="email"
                                autoComplete="username"
                                style={{width: '100%', marginBottom: 32}}
                                onKeyPress={(event) => this.handleKeyPress(event)}
                                onChange={(event) => {
                                    this.setState({email: event.target.value})
                                }}
                            />

                            <TextField
                                id="login_password_field"
                                placeholder="Password"
                                type="password"
                                autoComplete="current-password"
                                style={{width: '100%'}}
                                onKeyPress={(event) => this.handleKeyPress(event)}
                                onChange={(event) => {
                                    this.setState({password: event.target.value})
                                }}
                            />

                        </form>

                    </CardContent>
                    <CardActions style={{justifyContent: 'center'}}>
                        <Button
                            onClick={() => this.handleSignIn()}
                        >Login</Button>
                    </CardActions>
                </Card>
            </div>
        )
    }
}

export default compose(
    withRouter,
    withAuth,
)(Admin);
